{
  "es": {
    "question_list": {
      "actions": {
        "cancel": "Deshacer",
        "cancelOrder": "Cancelar",
        "delete": "Eliminar",
        "deleteMultipleQuestionLists": "Eliminar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "new": "Lista de preguntas",
        "reorderQuestions": "Reordenar preguntas",
        "save": "Guardar",
        "saveOrder": "Guardar orden",
        "submit": "Crear",
        "tickBoxesDeletion": "Marca las casillas de las preguntas frecuentes que quieras eliminar y, después, pulsa el botón de arriba para confirmar o cancelar la eliminación."
      },
      "attributes": {
        "description": "Descripción",
        "name": "Nombre",
        "question_list": "Preguntas frecuentes"
      },
      "labels": {
        "allUnits": "Todas las unidades",
        "descriptionOptional": "Descripción (opcional)",
        "editFAQ": "Editar preguntas frecuentes",
        "faq": "Preguntas frecuentes",
        "faq_all_projects": "FAQ de todos los proyectos",
        "info": "¿Tienes alguna pregunta sobre tu vivienda? Aquí tienes las preguntas más frecuentes y sus respuestas.",
        "questions": " Sin preguntas | 1 pregunta | {count} preguntas",
        "questions_count": "Preguntas",
        "showQuestionListFor": "Mostrar preguntas frecuentes de",
        "title": "Preguntas frecuentes"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Aquí encontrarás las respuestas a preguntas generales o a las que han hecho otras personas.",
            "title": "Preguntas frecuentes"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Ofrece respuestas a las preguntas generales que puedan tener tus clientes.",
            "title": "Crea tu primera lista de preguntas"
          }
        }
      },
      "toasts": {
        "create": "Lista de preguntas creada",
        "delete": "Lista de preguntas eliminada",
        "update": "Lista de preguntas actualizada"
      },
      "validation": {
        "needName": "El título es obligatorio",
        "selectQuestionList": "Selecciona al menos 1 lista de preguntas"
      }
    }
  }
}
